import React from "react"
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';

export interface InlineInfoBoxProps {
    type: "success" | "alert" | "error",
    text: string,
}

export const InlineInfoBox: React.FC<InlineInfoBoxProps> = ({type, text}) => {
    return (
        <div className={`flex flex-row ${type === "success" ? "border-green-600 bg-green-50" : type === "alert" ? "border-yellow-400 bg-yellow-50" : "border-red-600 bg-red-50"} items-center border-[1px] rounded-xl p-4 mb-4 mt-2 gap-3 inline-block`}>
            <div>
                {type === "success" &&
                    <CheckCircleIcon className="text-green-600"/>
                }   
                {type === "alert" &&
                    <InfoIcon className="text-yellow-600"/>
                }   
                {type === "error" &&
                    <ErrorIcon className="text-red-600"/>
                }   
            </div>
            <div className="text-left">
                {text}
            </div>
        </div>
    )
}